
// Sample data for the chart
export const demoData = [
  { name: "Game 1", Player1: 3, Player2: 2, Player3: 1, Player4: 0, Player5: 0 },
  { name: "Game 2", Player1: 2, Player2: 3, Player3: 0, Player4: 1, Player5: 0 },
  { name: "Game 3", Player1: 1, Player2: 2, Player3: 3, Player4: 0, Player5: 0 },
  { name: "Game 4", Player1: 3, Player2: 0, Player3: 1, Player4: 2, Player5: 0 },
  { name: "Game 5", Player1: 0, Player2: 2, Player3: 1, Player4: 0, Player5: 3 },
];

// Cumulative data for the chart
export const cumulativeData = demoData.reduce((acc, game, index) => {
  if (index === 0) {
    return [{ ...game }];
  }
  
  const prevGame = acc[index - 1];
  const newGame = { name: game.name };
  
  // Calculate cumulative values for each player
  for (const key in game) {
    if (key !== "name") {
      newGame[key] = (prevGame[key] || 0) + game[key];
    }
  }
  
  return [...acc, newGame];
}, [] as any[]);

// Player colors with better contrast
export const playerColors = {
  Player1: "#3B9FFF", // Brighter blue
  Player2: "#FF5252", // Brighter red
  Player3: "#4CAF50", // Brighter green
  Player4: "#FF9800", // Brighter orange
  Player5: "#BB86FC", // Brighter purple
};

export type ChartType = "line" | "cumulative";

// Helper to get the right dataset based on chart type
export const getChartData = (chartType: ChartType) => {
  return chartType === "line" ? demoData : cumulativeData;
};
